import {Component, OnInit} from '@angular/core';
import {ListComponent, ItemComponent} from '../commons/list.component';
import {AppComponent} from 'app/app.component';
import {ConfirmationService, MessageService} from 'primeng/api';
import {PartnerGroupsService} from './partner-groups.service';
import {Router, ActivatedRoute} from '@angular/router';
import {AppBreadcrumbService} from '../../app.breadcrumb.service';

@Component({
    selector: 'afm-partner-groups',
    templateUrl: '../commons/items.component.html',
    styleUrls: ['../commons/items.component.scss']
})
export  class PartnerGroupsComponent implements OnInit {

    title : string = 'Partner Groups Management'
    
    constructor() {}

    ngOnInit() {
    }

}

@Component({
    templateUrl: '../commons/list.component.html',
    styleUrls: ['../commons/items.component.scss']
})
export class PartnerGroupListComponent extends ListComponent implements OnInit {

    constructor(private cs: ConfirmationService, private ms: MessageService,private s: PartnerGroupsService, private a: AppComponent, private bs: AppBreadcrumbService) {
        super(cs,ms,s,a,bs);
    }

    ngOnInit() {
        super.ngOnInit()
        this.title = 'List of Partner Groups';
        
    }
    getPath(){
        return 'partner-group';
    }

    getCols(){
        return [
            { field: 'id', header: 'ID' ,placeHolder:'' ,width : '60px' },
            { field: 'name', header: 'Name',placeHolder:'',filtered : true,type : 'text' },
            { field: 'partnerCount', header: 'Partner Count',placeHolder:'' ,filtered : true,type : 'numeric'},
            { field: 'formCount', header: 'Form Count' ,placeHolder:'',filtered : true,type : 'numeric'}
        ];
    }
}
@Component({
    templateUrl: './partner-group.component.html',
    styleUrls: ['../commons/items.component.scss']
})
export class PartnerGroupComponent extends ItemComponent implements OnInit {

    constructor(private ms: MessageService, private s: PartnerGroupsService,
        private a: AppComponent, private rt: Router, private r: ActivatedRoute, private bs: AppBreadcrumbService) {
        super(ms,s,a,rt,r,bs);
    }

    ngOnInit() {
        super.ngOnInit()
    }
    
    getPath(){
        return 'partner-groups';
    }
    getSuccessMessage(){
        return 'Partner Group save with success';
    }

}

